import { render, staticRenderFns } from "./recentActivities.vue?vue&type=template&id=5ad0fc6a&"
import script from "./recentActivities.vue?vue&type=script&lang=js&"
export * from "./recentActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports